import React from 'react'

import IconCross from '../icons/IconCross'

import './index.css'

const BaseModal = (props) => {
  const preventWrapper = (e) => {
    e.stopPropagation()
  }

  return (
    <div className="modal__wrapper" onClick={props.onClose}>
      <div className="modal__modal" onClick={preventWrapper}>
        <span className="modal__close" onClick={props.onClose}><IconCross /></span>
        <div className="modal__body">
          {props.body}
        </div>
        {
          !!props.footer &&
          <div className={`modal__footer ${props.footerClassName}`}>
            {props.footer}
          </div>
        }
      </div>
    </div>
  )
}

export default BaseModal
